module.exports = __webpack_public_path__ + "img/oil_paint_large_2.531d57d2.png";